import axios from 'axios'
import { ActivationObject } from '../../components/providers/ActivationObjectProvider/types'
import { dateToApiString } from '../../utils/dateTimeUtils'
import { getRestApiConfig } from '../config'
import { AxiosErrorResult } from '../errors'
import { ActivationBody, ApiInterests, ApiPutInterests } from './types'

export const getActivationObject = async (synonym?: string): Promise<ActivationObject> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(`/api/v1/ObjectActivation?synonym=${synonym}`, restApiConfig.baseUrl).href
    const response = await axios.get<ActivationObject>(endpointUrl, { headers: { ...restApiConfig.authHeader } })
    return {
        ...response.data,
        loadedAt: new Date(),
        startProtection: response.data.startProtection ? new Date(response.data.startProtection) : undefined,
        endFreeProtection: response.data.endFreeProtection ? new Date(response.data.endFreeProtection) : undefined,
    }
}

export const postActivationObject = async (body: ActivationBody): Promise<ActivationObject> => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(`/api/v1/ObjectActivation`, restApiConfig.baseUrl).href

        const response = await axios.post<ActivationObject>(endpointUrl, body, { headers: { ...restApiConfig.authHeader } })
        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}

export const putActivationObject = async (object: ActivationObject) => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(`/api/v1/ObjectActivation`, restApiConfig.baseUrl).href
        const response = await axios.put<ActivationObject>(
            endpointUrl,
            {
                ...object,
                startProtection: object.startProtection ? dateToApiString(new Date(object.startProtection)) : undefined,
                endFreeProtection: object.endFreeProtection ? dateToApiString(new Date(object.endFreeProtection)) : undefined,
            },
            { headers: { ...restApiConfig.authHeader } }
        )
        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}

export const getInterests = async (synonym?: string): Promise<ApiInterests> => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(`/api/v1/ObjectActivation/Interests?synonym=${synonym}`, restApiConfig.baseUrl).href
        const response = await axios.get<ApiInterests>(endpointUrl, { headers: { ...restApiConfig.authHeader } })
        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}

export const putInterests = async (data: ApiPutInterests) => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(`/api/v1/ObjectActivation/Interests`, restApiConfig.baseUrl).href
        const response = await axios.put<ApiInterests>(endpointUrl, { ...data }, { headers: { ...restApiConfig.authHeader } })
        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}

export const putFinish = async (synonym: string): Promise<ActivationObject> => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(`/api/v1/ObjectActivation/Finish?synonym=${synonym}`, restApiConfig.baseUrl).href
        const response = await axios.put<ActivationObject>(endpointUrl, { synonym }, { headers: { ...restApiConfig.authHeader } })
        console.log(response.data)
        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}
